const DeploymentStateEnum = {};

DeploymentStateEnum.NONE = 0;
DeploymentStateEnum.FILE_AVAILABLE_MESSAGE_SENT = 1;
DeploymentStateEnum.TRANSFER_STARTED = 2;
DeploymentStateEnum.TRANSFER_COMPLETED = 4;
DeploymentStateEnum.INSTALLATION_STARTED = 8;
DeploymentStateEnum.INSTALLATION_COMPLETED = 16;
DeploymentStateEnum.CONNECTION_TIMEOUT = 32;
DeploymentStateEnum.INSTRUMENT_DISCONNECTED = 64;
DeploymentStateEnum.EXECUTION_STARTED = 128;
DeploymentStateEnum.EXECUTION_COMPLETED = 256;

DeploymentStateEnum.GetStateName = (enumValue) => {
  switch (enumValue) {
    case DeploymentStateEnum.NONE:
      return 'None';
    case DeploymentStateEnum.FILE_AVAILABLE_MESSAGE_SENT:
      return 'File available message sent';
    case DeploymentStateEnum.TRANSFER_STARTED:
      return 'Transfer started';
    case DeploymentStateEnum.TRANSFER_COMPLETED:
      return 'Transfer completed';
    case DeploymentStateEnum.INSTALLATION_STARTED:
      return 'Installation started';
    case DeploymentStateEnum.INSTALLATION_COMPLETED:
      return 'Installation completed';
    case DeploymentStateEnum.CONNECTION_TIMEOUT:
      return 'Connection timeout';
    case DeploymentStateEnum.INSTRUMENT_DISCONNECTED:
      return 'Instrument disconnected';
    case DeploymentStateEnum.EXECUTION_STARTED:
      return 'Execution started';
    case DeploymentStateEnum.EXECUTION_COMPLETED:
      return 'Execution completed';
    default:
      return 'Unknown';
  }
};

export default DeploymentStateEnum;
